import type { ReframeCollection, RFModule } from '@src/types/reframe';
import { MODULE_NAMES } from '@src/utils/modulenames';

const _collections: Map<string, ReframeCollection> = new Map(); // internal lookup
export const collections: ReframeCollection[] = $state([]);

export const add = (collection: ReframeCollection) => {
	_collections.set(collection.uuid, collection);
	orderCollections();
};
export const remove = (uuid: string) => {
	_collections.delete(uuid);

	const index = collections.findIndex((collection) => collection.uuid === uuid);

	if (index !== -1) collections.splice(index, 1);
};

export const get = (uuid: string) => {
	return _collections.get(uuid);
};

/**
 * Reorder collections based on dom order
 */
const orderCollections = () => {
	const domNodes = document.querySelectorAll(MODULE_NAMES.join(', '));

	collections.length = 0;

	Array.from(domNodes).forEach((node: Element) => {
		const _node = node as RFModule;
		const uuid = _node.collection?.uuid;
		const item = _collections.get(uuid);
		if (item) collections.push(item);
	});
};

export const collectionStore = {
	collections: {
		get items() {
			return [...collections];
		},
		add,
		remove,
		get,
	},
};
